/* vd-rsi-clic.js — VELDROP MX · 2026-09-10
   ---------------------------------------------------------------------------
   PARA QUE ES: en las paginas de producto que NO son landings del sistema de
   banners, el boton de compra es el del propio Releasit (app block). Ese boton
   nace DESHABILITADO ~1,4 s mientras la app crea el carrito, y por
   especificacion HTML un clic sobre un control deshabilitado no dispara nada:
   el cliente toca, no pasa nada, y vuelve a tocar. Eso es el "doble clic".

   COMO LO ARREGLA: medido en vivo, el navegador SI dispara `pointerdown` sobre
   un boton deshabilitado (aunque descarte `mousedown` y `click`). Aqui se
   escucha ese pointerdown, se confirma que fue un TOQUE y no un arrastre de
   scroll, y en cuanto el boton queda utilizable se le da el clic. El clic del
   cliente deja de perderse.

   LO QUE NO HACE, A PROPOSITO:
   - No pone ni una regla CSS sobre el formulario ni sobre nada .rsi-*.
   - No usa document.querySelector('#rsi_buy_now_button'): ese id esta DUPLICADO
     (el carrito lateral tiene otro). Se busca SIEMPRE dentro del hook del app
     block, nunca por id global.
   - No tapa el boton con ninguna capa: si este archivo fallara, la pagina se
     comporta exactamente como antes. No puede bloquear una compra.
   - No toca las landings: si la pagina carga un <pfx>-lp.js sale de inmediato,
     porque esas ya tienen su propio disparador arreglado. Ese es el
     discriminador correcto: mirar los CTAs .js-releasit NO sirve, porque la
     pagina del serum Anua tambien los tiene pero los cablea otro script
     (se2v2-script.js) que arrastra exactamente el mismo fallo.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* Las landings del sistema de banners ya se arreglan solas en su <pfx>-lp.js */
  for (var i = 0; i < document.scripts.length; i++) {
    if (/-lp\.js(\?|$)/.test(document.scripts[i].src || '')) return;
  }

  var ESPERA_MAX = 8000;   /* si en 8 s no se habilita, se rinde en silencio */
  var TAP_MS = 900;        /* pointerup dentro de este tiempo = toque */
  var TAP_PX = 14;         /* y dentro de esta distancia = no fue scroll */

  /* El boton real de Releasit. NUNCA por id global (#rsi_buy_now_button esta
     DUPLICADO: el carrito lateral tiene otro y abriria el form del carrito).
     Se busca SIEMPRE dentro de un contenedor conocido. */
  function botonDentroDe(cont) {
    if (!cont || !cont.querySelector) return null;
    return cont.querySelector('#rsi-button-hook button') || cont.querySelector('button') || null;
  }

  /* Dos formas de pedir el formulario en estas paginas:
     a) tocando el propio boton del app block (las 9 sin plantilla propia)
     b) tocando un CTA del tema .js-releasit que delega en el (serum Anua) */
  function botonSegunElToque(nodo) {
    if (!nodo || !nodo.closest) return null;
    var enApp = nodo.closest('#rsi-button-hook, .shopify-app-block');
    if (enApp) return botonDentroDe(enApp);
    if (nodo.closest('.js-releasit')) {
      return botonDentroDe(document.querySelector('.releasit-trigger')) ||
             botonDentroDe(document.querySelector('#rsi-button-hook')) ||
             botonDentroDe(document.querySelector('.releasit-appblock'));
    }
    return null;
  }

  function estaAbierto() {
    var i = document.querySelector('input[name="phone"]');
    if (!i) return false;
    var r = i.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /* Aviso propio, sin bloquear nada: pointer-events none siempre. */
  var aviso = null;
  function mostrarAviso() {
    if (aviso) return;
    aviso = document.createElement('div');
    aviso.setAttribute('role', 'status');
    aviso.textContent = 'Abriendo tu pedido…';
    aviso.style.cssText = [
      'position:fixed', 'left:50%', 'transform:translateX(-50%)',
      'bottom:calc(18px + env(safe-area-inset-bottom,0px))',
      'z-index:2147483000', 'pointer-events:none',
      'background:rgba(18,18,22,.94)', 'color:#fff',
      'font:500 14px/1.3 system-ui,-apple-system,Segoe UI,sans-serif',
      'padding:11px 18px', 'border-radius:100px',
      'box-shadow:0 10px 28px rgba(0,0,0,.45)'
    ].join(';');
    document.body.appendChild(aviso);
  }
  function quitarAviso() {
    if (aviso && aviso.parentNode) aviso.parentNode.removeChild(aviso);
    aviso = null;
  }

  var esperando = false;
  function abrirCuandoSePueda(btn) {
    if (esperando) return;
    esperando = true;
    mostrarAviso();
    var t0 = Date.now();
    var iv = setInterval(function () {
      if (estaAbierto()) { clearInterval(iv); esperando = false; quitarAviso(); return; }
      if (!btn.disabled) {
        clearInterval(iv);
        btn.click();
        var iv2 = setInterval(function () {
          if (estaAbierto() || Date.now() - t0 > ESPERA_MAX) {
            clearInterval(iv2); esperando = false; quitarAviso();
          }
        }, 120);
        return;
      }
      if (Date.now() - t0 > ESPERA_MAX) { clearInterval(iv); esperando = false; quitarAviso(); }
    }, 60);
  }

  /* Un pointerdown sobre el boton deshabilitado solo cuenta si termina en un
     toque limpio: si el dedo se mueve (scroll) o se cancela, se descarta. */
  var pendiente = null;

  document.addEventListener('pointerdown', function (e) {
    if (esperando || estaAbierto()) return;
    var btn = botonSegunElToque(e.target);
    if (!btn || !btn.disabled) return;      /* si ya esta usable, el clic normal funciona */
    pendiente = { btn: btn, x: e.clientX, y: e.clientY, t: Date.now() };
  }, true);

  document.addEventListener('pointerup', function (e) {
    var p = pendiente;
    pendiente = null;
    if (!p) return;
    if (Date.now() - p.t > TAP_MS) return;
    if (Math.abs(e.clientX - p.x) > TAP_PX || Math.abs(e.clientY - p.y) > TAP_PX) return;
    abrirCuandoSePueda(p.btn);
  }, true);

  document.addEventListener('pointercancel', function () { pendiente = null; }, true);
  window.addEventListener('pagehide', function () { quitarAviso(); });
})();
